import { GetterTree, ActionTree, MutationTree, Module } from 'vuex'
import { initRequestHelper, isAlreadyPending } from '../root'
import { ConfigState } from '../types/config'
import { RootState } from '../types/root'
import { apiGetConfig } from '@/api/config'

import { keys2Camel } from '@/services/objects'

const getDefaultState = (): ConfigState => {
  return {
    bundles: null,
    workstationTypes: null, //TODO: CHANGE FOR AUTHORIZED USERS
    region: null,
  }
}

const moduleState = getDefaultState()

const moduleGetters: GetterTree<ConfigState, RootState> = {
  region(state) {
    return state.region
  },
  bundles(state) {
    return state.bundles
  },
  workstationTypes(state, _getters, rootState_, rootGetters) {
    const profile = rootGetters['user/profile']
    const extraWorkstationCodenames: string[] = profile.extra_workstation_codenames || []
    return state.workstationTypes?.filter(
      (w) => w.selectable || extraWorkstationCodenames.includes(w.codename),
    )
  },
  selectableBundles(state) {
    return state.bundles?.filter((bundle) => bundle.selectable)
  },
  getConfigRequest(_state, _getters, rootState) {
    return rootState.requests.getConfig
  },

  getConfigRequestPending(_state, getters) {
    return isAlreadyPending(getters.getConfigRequest)
  },

  isRegionDisabled(state) {
    return !!state.region?.disabled
  },

  allowsSignUp(state, getters) {
    return true
    // return !getters.isRegionDisabled && state.region?.permissions?.user?.signup
  },
}

const moduleActions: ActionTree<ConfigState, RootState> = {
  async getConfig({ commit, getters }) {
    if (isAlreadyPending(getters.getConfigRequest)) return
    const [setSuccess, setFailure] = initRequestHelper(commit, 'getConfig')
    try {
      const rawConfig = await apiGetConfig()

      const translatedConfig = keys2Camel(rawConfig) as ConfigState

      commit('SET_CONFIG', translatedConfig)

      setSuccess()
    } catch (err: any) {
      setFailure(err.message)
      throw err
    }
  },
  resetConfigState({ commit }) {
    commit('RESET_STATE')
  },
}

const moduleMutations: MutationTree<ConfigState> = {
  SET_CONFIG(state, { bundles, region, workstationTypes }) {
    // for some reason, simple state = config does not update state.
    state.bundles = bundles
    state.region = region
    state.workstationTypes = workstationTypes
  },
  RESET_STATE(state) {
    state = getDefaultState()
  },
}

const config: Module<ConfigState, RootState> = {
  namespaced: true,
  // prefixed with "module-", so that they do not get shadowed by desctructured context
  state: moduleState,
  getters: moduleGetters,
  actions: moduleActions,
  mutations: moduleMutations,
}
export default config
